import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as classnames from 'classnames';
import { IStore } from '../../../domain/store/IStore';
import '@material/snackbar/dist/mdc.snackbar.css';
import '@material/button/dist/mdc.button.css';

interface IProps {
  store?: IStore;
}

@inject('store')
@observer
export default class Snackbar extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { uiState } = this.store;
    return (
      <div
        className={classnames('mdc-snackbar', { 'mdc-snackbar--active': uiState.snackbar.isActive })}
        aria-live="assertive"
        aria-atomic="true"
        aria-hidden={!uiState.snackbar.isActive}
      >
        <div className="mdc-snackbar__text">{uiState.snackbar.isActive ? uiState.snackbar.message : null}</div>
        <div className="mdc-snackbar__action-wrapper">
          <button
            type="button"
            className="mdc-button mdc-snackbar__action-button"
            onClick={uiState.snackbar.actionHandler}
          >
            {uiState.snackbar.isActive ? uiState.snackbar.actionText : null}
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/base/Snackbar.tsx